<template>
  <div>
    <AdvertisingCampaign
      class="mb-24"
      :campaign="campaign"
      :key="campaign._id"
      @deleted="fetchCampaigns()"
      v-for="campaign in campaigns"
    />

    <AddCampaignModal
      @created="
        add_modal = false;
        fetchCampaigns();
      "
      @close="add_modal = false"
      v-if="add_modal"
    />
  </div>
</template>

<script>
import AdvertisingCampaign from "@/components/marketing/AdvertisingCampaign.vue";

import AddCampaignModal from "@/components/marketing/AddCampaignModal.vue";

import ReferralsAPI from "@/api/referrals";

import Popup from "@/components/PopUp.vue";

export default {
  components: {
    AdvertisingCampaign,
    AddCampaignModal,
    Popup,
  },
  data() {
    return {
      campaigns: [],

      add_modal: false,
    };
  },
  methods: {
    fetchCampaigns() {
      ReferralsAPI.getCampaigns()
        .then((data) => {
          this.campaigns = data.campaigns;
        })
        .catch((error) => {
          this.$store.dispatch("showError", "referrals_error");
        });
    },
    showAddCampaignUI() {
      this.add_modal = true;
    },
  },
  mounted() {
    this.fetchCampaigns();
  },
};
</script>

<style>
</style>